export * from "./atoms";

import { RoomContentAtoms } from "./atoms";

export const RoomContentComponents = [
    ...RoomContentAtoms
]